import React from "react";
import { Loading } from "../panels";
import Google from "./Google";

interface IProps {
  className?: string
  googleConnectAbsolute: string
  googleUserDetails?: server.dto.GoogleIdentityUserDetails
  allowDisconnect: boolean
  settingsUrl?: string
}

const ExternalIdentities = (props: IProps) => {
  const [googleUserDetails, setGoogleUserDetails] = React.useState<server.dto.GoogleIdentityUserDetails>(props.googleUserDetails);
  const [isFetching, setIsFetching] = React.useState<boolean>(false);
  const [fetchingError, setFetchingError] = React.useState<boolean>(false);

  React.useEffect(() => {
    const fetchData = async () => {
      setIsFetching(true);
      const googleDetails = await window.CoreApi.Google.MyDetails();
      if (googleDetails.data.hasErrors) {
        setFetchingError(true);
        setIsFetching(false);
        return;
      }
      setGoogleUserDetails(googleDetails.data.data);
      setIsFetching(false);
    }
    fetchData();
  }, []);

  if (isFetching) {
    return <div>
      <Loading />
    </div>;
  }

  if (fetchingError) {
    return <div>
      There was an error fetching the connected accounts data
    </div>;
  }

  return (<>
    <div>
      <Google
        userDetails={googleUserDetails}
        canDisconnect={props.allowDisconnect}
        connectUrl={props.googleConnectAbsolute}
        settingsUrl={props.settingsUrl} />
    </div>

    {(((!googleUserDetails)) && props.allowDisconnect) && <div className="s1_gray margin-top" style={{ textAlign: "center" }}>
      {RESX.PersonalSettings.ConnectYourAccount}
    </div>}
  </>);
};

export default ExternalIdentities;